import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import repository from '../services/ShopExportProfileRepository';
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
import translate from '@astina/paloma-common-ui/src/services/Translator';
export function saveShopExportProfile(profile) {
    return new SaveShopExportProfile(profile)
        .enqueue();
}
export default class SaveShopExportProfile extends AbstractCommand {
    profile;
    constructor(profile) {
        super();
        this.profile = profile;
    }
    execute() {
        return repository.save(this.profile)
            .then(profile => {
            alerts.success(translate('shop_export_profiles.save_success'));
            return profile;
        });
    }
    needsConfirmation() {
        return true;
    }
    name() {
        return 'save_shop_export_profile';
    }
    icon() {
        return 'save';
    }
    requiresPermission() {
        return 'PORTAL_INTEGRATIONS_EXPORT';
    }
}
